<template>
  <f7-page class="main-FrmNewOrder-page">
    <template #fixed>
      <TheNavbar
        class="container-navbar"
        :nav-title="$t('commercialization.common.newSalesOrder')"
        back-btn-enable
        :back-callback="callBackBtn"
      >
        <template #btn-right>
          <f7-link @click="PressNextPage()">
            <img
              src="@/static/icons/btn-next.svg"
              height="38px"
              width="38px"
            >
          </f7-link>
        </template>
      </TheNavbar>
    </template>

    <div class="content-data">
      <div class="display-flex">
        <UCDatePicker
          id="date-filter-Delivery"
          ref="datepickerDelivery"
          :title="$t('common.deliveryDate')"
          class="w-100"
          @onchange="ChangedDateDelivery"
        />
      </div>
      <div class="display-flex">
        <UCDatePicker
          id="date-filter-Departure"
          ref="datepickerDeparture"
          :title="$t('common.departureDate')"
          class="w-100"
          @onchange="ChangedDateDeparture"
        />

        <UCTimePicker
          id="time-picker-from"
          ref="horaNewRecord"
          class="ml-2 w-100"
          :title="$t('common.departureHour')"
          template="P2"
          @onchange="ChangedTimeDeparture"
        />
      </div>
      <UCSearchEntityERP
        ref="UCReferecia"
        :title="$t('common.reference')"
        :placeholder="$t('searchEntity.reference.placeholder.searchByReference')"
        :search-text="$t('searchEntity.reference.searchText')"
        :search-cancellation-text="$t('searchEntity.reference.searchCancellationText')"
        :search-not-found-text="$t('searchEntity.reference.searchNotFoundText')"
        :min-text-search="0"
        :autofocus-on-deselection="true"
        :auto-focus-on-empty-search-result="true"
        :show-btn-search="false"
      />
      <UCSearchEntityERP
        ref="UCClient"
        :title="$t('common.customer')"
        :placeholder="$t('searchEntity.client.placeholder.searchByClient')"
        :search-text="$t('searchEntity.client.searchText')"
        :search-cancellation-text="$t('searchEntity.client.searchCancellationText')"
        :search-not-found-text="$t('searchEntity.client.searchNotFoundText')"
        :procedure-for-search="clientProcedure"
        :default-value="clienteSelected"
        :property-entity-shown-input="['Nombre']"
        :property-entity-shown-list-title="['Nombre']"
        :property-entity-shown-list-subtitle="['Codigo']"
        :min-text-search="0"
        :autofocus-on-deselection="true"
        :auto-focus-on-empty-search-result="true"
        @selection="EventclienteSelected"
      />
      <UCSearchEntityERP
        :title="$t('common.shippingAddress')"
        :placeholder="$t('searchEntity.address.placeholder.searchByAddress')"
        :search-text="$t('searchEntity.address.searchText')"
        :search-cancellation-text="$t('searchEntity.address.searchCancellationText')"
        :search-not-found-text="$t('searchEntity.address.searchNotFoundText')"
        :procedure-for-search="directionProcedure"
        :disabled="clienteSelected == null"
        :default-value="direccionSelected"
        :property-entity-shown-input="['Nombre', 'Direccion']"
        :property-entity-shown-list-title="['Nombre']"
        :property-entity-shown-list-subtitle="['Direccion']"
        :min-text-search="0"
        :autofocus-on-deselection="true"
        :auto-focus-on-empty-search-result="true"
        @selection="EventDireccionSelected"
      />
      <UCSearchEntityERP
        ref="UCSalesRateSearch"
        :title="$t('common.salesRate')"
        :placeholder="$t('searchEntity.salesRate.placeholder.searchBySalesRate')"
        :search-text="$t('searchEntity.salesRate.searchText')"
        :search-cancellation-text="$t('searchEntity.salesRate.searchCancellationText')"
        :search-not-found-text="$t('searchEntity.salesRate.searchNotFoundText')"
        :procedure-for-search="salesRateProcedure"
        :default-value="salesRateSelected"
        :disabled="clienteSelected == null"
        :property-entity-shown-input="['Nombre', 'Codigo']"
        :property-entity-shown-list-title="['Nombre']"
        :property-entity-shown-list-subtitle="['Codigo']"
        :min-text-search="0"
        :autofocus-on-deselection="true"
        :auto-focus-on-empty-search-result="true"
        @selection="EventSalesRateSelected"
      />
    </div>
    <InfoSheet
      :state="infoSheetParams.state"
      :opened="infoSheetParams.opened"
      :title="infoSheetParams.title"
      :subtitle1="infoSheetParams.subtitle1"
      @closed="infoSheetParams.opened = false"
    />
  </f7-page>
</template>

<script>
import { mapActions, mapState, mapWritableState } from 'pinia';
import { useAppOrdersStore } from '@/js/stores/appOrders';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useParamRef } from '@erpagroapp/params';

import TheNavbar from '@/components/TheNavbar.vue';
import InfoSheet from '@/components/common/InfoSheet.vue';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import { HiNotification, ConfirmDialogGH } from '@/js/common/HINotificationSupport';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import UCTimePicker from '@/components/common/UCTimePicker.vue';
import APIErp, { callExecuteSPERP } from '@/js/services/APIErp';
import { Log } from '@/js/common/HIDebuggingSupport';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';
import { TipoBloqueo } from '@/js/common/enum';

/**
 * @import {
 * InfoSheetState,
 * SPApp,
 * } from '@erpagroapp/types' */

export default {
  name: 'FrmNewOrder',
  components: {
    TheNavbar,
    UCSearchEntityERP,
    UCDatePicker,
    UCTimePicker,
    InfoSheet,
  },
  props: {
    editarCabecera: { type: Boolean, default: false },
  },

  data() {
    return {
      deliveryDate: new Date(), // Fecha de creacion
      referenciaSelected: null,
      clienteSelected: null,
      clienteForSalesRateSelected: null,
      direccionSelected: null,
      salesRateSelected: null,
      departureTime: null,
      departureDate: new Date(), // Fecha de salida
      infoSheetParams: {
        opened: false,
        subtitle1: '',
        title: '',
        /** @type {InfoSheetState} */
        state: 'CAUTION',
      },
      filtrarPedidosVentaVendedorAPP: useParamRef('FiltrarPedidosVentaVendedorAPP'),
      tarifaPorDefecto: useParamRef('TarifaPorDefecto'),
    };
  },
  computed: {
    ...mapState(useAppOrdersStore, ['estadoPedidoCopiado']),

    ...mapWritableState(useAppOrdersStore, [
      'dataClient',
      'actualOrder',
    ]),

    ...mapState(useAppConfigStore, ['userEnviroment']),

    sellerSubjectId() {
      return this.filtrarPedidosVentaVendedorAPP
        ? this.userEnviroment.EntornoDeTrabajo.Usuario.Sujeto?.Id
        : 0;
    },

    clientProcedure() {
      return /** @satisfies {SPApp} */ ({
        NombreSP: 'APPERPAGRO_ClientesXIdGrupoEmpresarial',
        Parametros: [
          { NombreParametro: 'filtro', Valor: 'q:' },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idEmpresa', Valor: this.userEnviroment.EntornoDeTrabajo.Empresa?.Id },
          { NombreParametro: 'fechaComprobacionBloqueos', Valor: new Date() },
          { NombreParametro: 'idSujetoVendedor', Valor: this.sellerSubjectId },
        ],
        EntidadMapear: 'Comun.ClienteJSON',
      });
    },
    directionProcedure() {
      return /** @satisfies {SPApp} */ ({
        NombreSP: 'APPERPAGRO_DireccionesXidSujeto',
        Parametros: [
          { NombreParametro: 'filtro', Valor: 'q:' },
          { NombreParametro: 'idSujeto', Valor: this.clienteSelected != null ? this.clienteSelected.Sujeto.Id : '' },
        ],
        EntidadMapear: 'DireccionJSON',
      });
    },

    salesRateProcedure() {
      return /** @satisfies {SPApp} */ ({
        NombreSP: 'APPERPAGRO_TarifasVentaXFiltro',
        Parametros: [
          { NombreParametro: 'filtro', Valor: 'q:' },
          { NombreParametro: 'idCliente', Valor: 0 },
          { NombreParametro: 'idEmpresa', Valor: this.userEnviroment.EntornoDeTrabajo.Empresa?.Id },
        ],
        EntidadMapear: 'Ventas.TarifaVentaJSON',
      });
    },
  },
  mounted() {
    this.StartComponent();
  },

  methods: {
    ...mapActions(useAppOrdersStore, ['resetValuesApp']),

    StartComponent() {
      Log(this, this.StartComponent.name);
      if (this.estadoPedidoCopiado || this.editarCabecera) {
        this.$refs.UCReferecia.setInputValue(this.actualOrder.Referencia);
        this.clienteSelected = this.actualOrder.Cliente;
        this.clienteForSalesRateSelected = this.actualOrder.Cliente;
        this.direccionSelected = this.actualOrder.DireccionEnvio;
        if (this.actualOrder.TarifaVenta) {
          this.salesRateSelected = this.actualOrder.TarifaVenta;
        }
        if (this.editarCabecera) {
          this.$refs.datepickerDeparture.setDate(new Date(this.actualOrder.FechaSalida));
          this.$refs.datepickerDelivery.setDate(new Date(this.actualOrder.FechaEntrega));
          this.$refs.horaNewRecord.SetTime(new Date(this.actualOrder.FechaSalida));
        }
        this.checkSalesRate();
      }
    },
    async callBackBtn() {
      if (this.editarCabecera) {
        f7.views.main.router.navigate('/OrderDetail/', {
          ignoreCache: true,
          reloadPrevious: true,
          props: {
            nuevoPedido: true,
            navbarBtn: true,
            mostrarBtnNextAdd: true,
            mostrarOnlyBtnAdd: true,
            mostrarToolbar: true,
          },
        });
        await sleep(500);
        f7.views.main.router.back();
      } else {
        this.resetValuesApp();
        f7.views.main.router.back();
      }
    },
    async Checkreference() {
      Log(this, this.Checkreference.name);
      const inputValue = this.$refs.UCReferecia.GetInputValue();
      if (inputValue === '') {
        return false;
      }
      this.referenciaSelected = inputValue;
      return true;
    },
    async PressNextPage() {
      Log(this, this.PressNextPage.name);
      let faltanDatos = false;
      const emptyFields = [];

      if (this.deliveryDate === null) {
        emptyFields.push(this.$t('common.deliveryDate'));
        faltanDatos = true;
      }
      if (this.departureDate === null) {
        emptyFields.push(this.$t('common.departureDate'));
        faltanDatos = true;
      }
      if (this.departureTime === null) {
        emptyFields.push(this.$t('common.departureHour'));
        faltanDatos = true;
      }
      this.Checkreference();
      /* if (!this.Checkreference()) {
        faltanDatos = true;
      } */
      if (this.clienteSelected === null) {
        emptyFields.push(this.$t('common.customer'));
        faltanDatos = true;
      }
      if (this.direccionSelected === null || this.direccionSelected === undefined) {
        emptyFields.push(this.$t('common.address'));
        faltanDatos = true;
      }

      if (faltanDatos) {
        const errorMessage = this.$t('commercialization.common.needToFillFields', { text: emptyFields.join(', ') });
        HiNotification.Toast(errorMessage);
      } else if (!this.editarCabecera) {
        // TODO: Metodo para crear un nuevo pedido
        const resOrder = {
          FechaEntrega: this.GetDate(this.deliveryDate, null),
          FechaSalida: this.GetDate(this.departureDate, this.departureTime),
          Referencia: this.referenciaSelected,
          Cliente: this.clienteSelected,
          DireccionEnvio: this.direccionSelected,
          TarifaVenta: this.salesRateSelected,
          Observaciones: null,
          Serie: '',
          Numero: '',
          Id: 0,
          lineasPedidoVenta: [],
          NombreTransportista: '',
        };

        this.dataClient = this.clienteSelected;
        if (!this.estadoPedidoCopiado) {
          this.actualOrder = resOrder;
        } else {
          this.actualOrder.FechaEntrega = this.GetDate(this.deliveryDate, null);
          this.actualOrder.FechaSalida = this.GetDate(this.departureDate, this.departureTime);
          this.actualOrder.Referencia = this.referenciaSelected;
          this.actualOrder.Cliente = this.clienteSelected;
          this.actualOrder.DireccionEnvio = this.direccionSelected;
          this.actualOrder.TarifaVenta = this.salesRateSelected;

          if (this.actualOrder.TarifaVenta !== null) {
            const shouldContinue = await ConfirmDialogGH(
              'Los precios se actualizarán a la última tarifa vigente',
              '¿Quiere actualizar los precios del pedido?',
            );

            if (shouldContinue) {
              if (this.actualOrder.lineasPedidoVenta && this.actualOrder.lineasPedidoVenta.length > 0) {
                this.GetPriceXSalesRateXProduction();

                await sleep(800);
              }
            }
          }
        }

        f7.views.main.router.navigate('/OrderDetail/', {
          props: {
            nuevoPedido: true,
            navbarBtn: true,
            mostrarBtnNextAdd: true,
            mostrarOnlyBtnAdd: true,
            mostrarToolbar: true,
          },
        });
      } else {
        this.dataClient = this.clienteSelected;
        this.actualOrder.FechaEntrega = this.GetDate(this.deliveryDate, null);
        this.actualOrder.FechaSalida = this.GetDate(this.departureDate, this.departureTime);
        this.actualOrder.Referencia = this.referenciaSelected;
        this.actualOrder.Cliente = this.clienteSelected;
        this.actualOrder.DireccionEnvio = this.direccionSelected;
        this.actualOrder.TarifaVenta = this.salesRateSelected;

        f7.views.main.router.navigate('/OrderDetail/', {
          ignoreCache: true,
          reloadPrevious: true,
          props: {
            nuevoPedido: true,
            navbarBtn: true,
            mostrarBtnNextAdd: true,
            mostrarOnlyBtnAdd: true,
            mostrarToolbar: true,
          },
        });
        await sleep(500);
        f7.views.main.router.back();
      }
    },

    async GetPriceXSalesRateXProduction() {
      Log(this, this.GetPriceXSalesRateXProduction.name);
      this.actualOrder.lineasPedidoVenta.forEach(async (linea) => {
        const result = await APIErp.callPriceXSalesRateXProduction(this.actualOrder.TarifaVenta.Id, this.actualOrder.FechaSalida, linea.InfoEnvase.Id, linea.Articulo.Id, linea.Articulo.Familia.Id);

        if (result.statusText === 'OK') {
          const tag = result.data.Tag;
          if (!tag) {
            const unidadMedida = await this.GetUnidadesDeMedida(linea.Articulo.Id, linea.InfoEnvase.Id, linea.InfoPale.Id);
            linea.Precio = 0;
            linea.PrecioPor = unidadMedida ?? linea.PrecioPor;
          } else {
            const itemCurrency = tag.PreciosDivisa?.filter((f) => f.divisa.id === this.userEnviroment.EntornoDeTrabajo.IdDivisaFuncional);
            if (itemCurrency[0]) {
              const tagPrecioPor = tag.precioPor ?? {};
              const lineaPrecioPor = linea.PrecioPor ?? {};

              linea.Precio = itemCurrency[0].precio ?? linea.Precio;
              linea.PrecioPor = {
                Codigo: tagPrecioPor.codigo ?? lineaPrecioPor.Codigo ?? '',
                Id: tagPrecioPor.id ?? lineaPrecioPor.Id ?? 0,
                Abreviatura: tagPrecioPor.abreviatura ?? lineaPrecioPor.Abreviatura ?? '',
                Nombre: tagPrecioPor.nombre ?? lineaPrecioPor.Nombre ?? '',
              };
            }
          }
        }
      });
    },

    async GetUnidadesDeMedida(idProducto, idEnvase, idPale) {
      const result = await APIErp.callGetUnitsMeasuredByItem(idProducto, idEnvase, idPale);

      if (result.status === 200) {
        const tag = result.data.Tag;
        if (tag != null) {
          return {
            Id: tag[0].unidadMedida.id,
            Codigo: tag[0].unidadMedida.codigo,
            Nombre: tag[0].unidadMedida.nombre,
          };
        }
      }

      return null;
    },

    PressMisPedidos() {
      Log(this, this.PressMisPedidos.name);
      f7.views.main.router.navigate('/QueryOrders');
    },
    EventReferenciaSelected(obj) {
      Log(this, this.EventReferenciaSelected.name);
      this.referenciaSelected = obj;
    },

    EventclienteSelected(obj) {
      Log(this, this.EventclienteSelected.name);
      this.clienteSelected = obj;
      if (obj) {
        const block = this.checkBlocks(obj);
        if (block) {
          this.$refs.UCClient.Clear();
          return;
        }
        this.GetDirection().then((result) => {
          if (result.data.length > 0) {
            const resultado = result.data;
            const direccionesEnvio = resultado.filter((obj2) => obj2.UsoDireccion === 'Envio');
            let direccionEnvioDefecto;
            if (direccionesEnvio.length > 1) {
              direccionEnvioDefecto = direccionesEnvio.find((obj3) => obj3.UsoDefecto === true);
              this.direccionSelected = direccionEnvioDefecto;
            } else if (direccionesEnvio.length === 1) {
              [direccionEnvioDefecto] = direccionesEnvio;
              this.direccionSelected = direccionEnvioDefecto;
            }
          }
        });
        this.checkSalesRate();
      } else {
        this.$refs.UCSalesRateSearch.Clear();
      }
    },

    EventDireccionSelected(obj) {
      Log(this, this.EventDireccionSelected.name);
      this.direccionSelected = obj;
    },
    EventSalesRateSelected(obj) {
      Log(this, this.EventSalesRateSelected.name);
      this.salesRateSelected = obj;
    },

    async checkSalesRate() {
      Log(this, this.EventSalesRateSelected.name);
      if (this.clienteSelected) {
        this.GetSalesRate('', this.clienteSelected.Id).then((result) => {
          if (result.data.length > 0) {
            const resultado = result.data;
            this.salesRateSelected = resultado[0];
          }
        });
      }

      if ((this.salesRateSelected === null || this.salesRateSelected.length === 0) && this.tarifaPorDefecto) {
        this.GetSalesRate(`Id:${this.tarifaPorDefecto}`, 0).then((result) => {
          if (result.data.length > 0) {
            const resultado = result.data;
            this.salesRateSelected = resultado[0];
          }
        });
      }
    },

    checkBlocks(item) {
      let hasBlocking = false;
      let tipeOutOfUse = null;
      let tipeBlock = null;
      let tipeWarning = null;

      if (item.Bloqueos) {
        for (const block of item.Bloqueos) {
          if (block.TipoBloqueo === TipoBloqueo.FueraDeUso) {
            tipeOutOfUse = block;
          } else if (block.TipoBloqueo === TipoBloqueo.Bloqueo) {
            tipeBlock = block;
          } else if (block.TipoBloqueo === TipoBloqueo.Aviso) {
            tipeWarning = block;
          }
        }
      }

      if (tipeOutOfUse) {
        hasBlocking = true;
        this.infoSheetParams.opened = true;
        this.infoSheetParams.subtitle1 = tipeOutOfUse.Motivo ?? '';
        this.infoSheetParams.title = this.$t('common.outOfUse');
        this.infoSheetParams.state = 'ERROR';
      } else if (tipeBlock) {
        hasBlocking = true;
        this.infoSheetParams.opened = true;
        this.infoSheetParams.subtitle1 = tipeBlock.Motivo ?? '';
        this.infoSheetParams.title = this.$t('common.block');
        this.infoSheetParams.state = 'ERROR';
      } else if (tipeWarning) {
        this.infoSheetParams.opened = true;
        this.infoSheetParams.subtitle1 = tipeWarning.Motivo ?? '';
        this.infoSheetParams.title = this.$t('common.warning');
        this.infoSheetParams.state = 'CAUTION';
      }
      return hasBlocking;
    },
    ChangedDateDelivery(newDateValue) {
      Log(this, this.ChangedDateDelivery.name);
      this.deliveryDate = newDateValue;
    },
    ChangedDateDeparture(newDateValue) {
      Log(this, this.ChangedDateDeparture.name);
      this.departureDate = newDateValue;
    },

    ChangedTimeDeparture(newTimeValue) {
      Log(this, this.ChangedTimeDeparture.name);
      this.departureTime = newTimeValue;
    },

    GetDate(valDate, valHour) {
      Log(this, this.GetDate.name);
      // const fecha = new Date('Thu Jun 15 2023 14:04:29 GMT+0200 (hora de verano de Europa central)');
      const fecha = valDate;
      const year = fecha.getFullYear();
      const month = String(fecha.getMonth() + 1).padStart(2, '0');
      const day = String(fecha.getDate()).padStart(2, '0');
      let minutes = '00';
      let hour = '00';
      if (valHour != null) {
        const partesHora = valHour.split(':');
        hour = String(partesHora[0]);
        if (hour.length === 1) {
          hour = `0${hour}`;
        }
        minutes = String(partesHora[1]);
      }

      const formattedDate = `${year}-${month}-${day}T${hour}:${minutes}:00`;
      return formattedDate;
    },

    GetDirection() {
      Log(this, this.GetDirection.name);
      return callExecuteSPERP(
        'APPERPAGRO_DireccionesXidSujeto',
        [
          { NombreParametro: 'filtro', Valor: '' },
          { NombreParametro: 'idSujeto', Valor: this.clienteSelected?.Sujeto?.Id ?? '' },
        ],
        'DireccionJSON',
      );
    },
    GetSalesRate(filtro, idCliente) {
      Log(this, this.GetSalesRate.name);
      return callExecuteSPERP(
        'APPERPAGRO_TarifasVentaXFiltro',
        [
          { NombreParametro: 'filtro', Valor: filtro ?? 'q:' },
          { NombreParametro: 'idCliente', Valor: idCliente ?? 0 },
          { NombreParametro: 'idEmpresa', Valor: this.userEnviroment.EntornoDeTrabajo.Empresa?.Id },
        ],
        'Ventas.TarifaVentaJSON',
      );
    },
  },
};
</script>

<style lang="scss">
.main-FrmNewOrder-page {
  .page-content {
    overflow-y: hidden;
  }
  .container-navbar{
    .navbar-inner {
      .title {
          font-size: 16px;
          font-weight: 400;
      }
    }
  }
  .content-data {
    overflow-y: scroll;
    height: calc(100vh - 55px);
    padding: 10px 15px 0px 15px;
    --date-picker-label-color: var(--his-tierra);
    --search-title-color: var(--his-tierra);
    --date-picker-input-color: var(--his-tierra);
  }
}
</style>
